module.exports = __webpack_public_path__ + "static/media/Asset720.ccd5b1dc.png";